import {
  ServiceOutline18Icon,
  TimeOutline18Icon,
  TownOutline18Icon,
  TrainOutline18Icon,
  WarningFill18Icon,
  WarningOutline18Icon,
} from "@vygruppen/spor-icon-react";
import {
  DisplayDuration,
  getDisplayDurationString,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/utils";
import { FC } from "react";
import { FlexProps, HStack, Text as SporText } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import { InfrastructureIncidentIcon18 } from "shared/icons/InfrastructureIncidentIcon18";
import styled, { useTheme } from "styled-components";

export const CustomOutlineBadge = styled.div`
  border-radius: 30px;
  border: 1px solid ${({ theme }) => theme.colorOutlineMain};
  padding: 2px 12px;
`;

const getLabel = (category: EventCategory) => {
  switch (category) {
    case "plannedInfrastructure":
      return "Planlagt";
    case "futureInfrastructure":
      return "Oppstått";
    case "global":
      return "Global driftsmelding";
    case "internal":
      return "Global intern melding";
    case "productionDeviation":
      return "Produksjonsavvik";
    case "station":
      return "Stasjon";
    case "train":
      return "Tog";
    case "infrastructure":
      return "Infrastruktur";
    case "trainEvent":
      return "Toghendelse";
    case "stationEvent":
      return "Stasjonshendelse";
  }
};

const getIcon = (eventType: EventCategory) => {
  switch (eventType) {
    case "plannedInfrastructure":
      return <TimeOutline18Icon />;
    case "futureInfrastructure":
      return <InfrastructureIncidentIcon18 />;
    case "global":
      return <WarningFill18Icon />;
    case "internal":
      return <WarningFill18Icon />;
    case "productionDeviation":
      return <ServiceOutline18Icon />;
    case "station":
      return <TownOutline18Icon />;
    case "train":
      return <TrainOutline18Icon />;
    case "infrastructure":
      return <InfrastructureIncidentIcon18 />;
    case "trainEvent":
      return <WarningOutline18Icon />;
    case "stationEvent":
      return <WarningOutline18Icon />;
  }
};

export type EventCategory =
  | "plannedInfrastructure"
  | "futureInfrastructure"
  | "global"
  | "internal"
  | "station"
  | "train"
  | "infrastructure"
  | "trainEvent"
  | "stationEvent"
  | "productionDeviation";

type BadgeProps = {
  eventCategory?: EventCategory;
  displayDuration?: DisplayDuration | null;
  variant?: "xs" | "sm";
} & Omit<FlexProps, "direction">;

export const Badges: FC<BadgeProps> = ({
  eventCategory,
  displayDuration,
  variant = "sm",
  ...props
}) => {
  const theme = useTheme();
  return (
    <HStack {...props}>
      {eventCategory && (
        <CustomOutlineBadge>
          <HStack gap="6px">
            {getIcon(eventCategory)}
            <Text>{getLabel(eventCategory)}</Text>
          </HStack>
        </CustomOutlineBadge>
      )}
      {displayDuration !== undefined && (
        <SporText
          variant={variant}
          fontWeight="regular"
          color={theme.colorNeutralTextMain}
        >
          {getDisplayDurationString(displayDuration)}
        </SporText>
      )}
    </HStack>
  );
};
